import styled from "styled-components";
import { themed, } from "@bracket/ui";


export type FloatedImageProps = {
	url: string;
	style?: React.CSSProperties;
	width?: string | number;
	height?: string | number;
	position?: "absolute" | "relative" | "fixed" | "sticky" | "static";
	top?: string | number;
	right?: string | number;
	bottom?: string | number;
	left?: string | number;
	zIndex?: number;
	invertColors?: boolean;
};



/**
 * FloatedImage React component
 *
 * @param {Object} props - React props object
 * @param {string} props.url - image url (relative or absolute)
 * @param {React.CSSProperties} [props.style] - style override for precise positioning or sizing
 * @param {string | number} [props.width] - CSS width for the image (defaults to 32px)
 * @param {string | number} [props.height] - CSS height for the image (defaults to 32px)
 * @param {string} [props.position] - CSS position property (defaults to 'absolute')
 * @param {string | number} [props.top] - CSS top positioning
 * @param {string | number} [props.right] - CSS right positioning
 * @param {string | number} [props.bottom] - CSS bottom positioning
 * @param {string | number} [props.left] - CSS left positioning
 * @returns {JSX.Element}
 */
export const FloatedImage = ({
	url,
	style = {},
	width = 332,
	height = 332,
	position = "absolute",
	top,
	right,
	bottom,
	left,
	zIndex,
	invertColors = false,
}: FloatedImageProps) => {
	themed();

	return (
		<ImageBrace
			$position={position}
			$width={width}
			$height={height}
			$top={top}
			$right={right}
			$bottom={bottom}
			$left={left}
			$zIndex={zIndex}
			style={style}
		>
			<img
				src={url}
				alt=""
				draggable={false}
				style={{
					width: "100%",
					height: "100%",
					display: "block",
					objectFit: "contain",
					pointerEvents: "none",
					userSelect: "none",
					filter: invertColors ? "invert(1)" : "none",
				}}
			/>
		</ImageBrace>
	);
};





const ImageBrace = styled.div<{
	$position: "absolute" | "relative" | "fixed" | "sticky" | "static";
	$width: string | number;
	$height: string | number;
	$top?: string | number;
	$right?: string | number;
	$bottom?: string | number;
	$left?: string | number;
	$zIndex?: number;
}>`
	position: ${({ $position }) => $position};
	width: ${({ $width }) => $width !== undefined ? $width : "auto"};
	height: ${({ $height }) => $height !== undefined ? $height : "auto"};
	top: ${({ $top }) => $top !== undefined ? $top : "auto"};
	right: ${({ $right }) => $right !== undefined ? $right : "auto"};
	bottom: ${({ $bottom }) => $bottom !== undefined ? $bottom : "auto"};
	left: ${({ $left }) => $left !== undefined ? $left : "auto"};
	z-index: ${({ $zIndex }) => $zIndex !== undefined ? $zIndex : "auto"};
	pointer-events: none;
	img {
		svg {
			fill: white:!important;
		}
	}
`;
